import fwUtil from 'framework-util'
export const generalTableService=new fwUtil.ApiService.ApiService('generalTable');


// WEBPACK FOOTER //
// ./src/api/generator/generator/generalTable.js